import styled, { css } from "styled-components";

import { StyledInput } from "shared/atoms/inputs/StyledInputs";
import { TextArea } from "shared/atoms/inputs/TextArea";
import { museoSansFont } from "theme/muiTheme";

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledParagraph = styled.p`
  white-space: pre-wrap;
  font: ${({ theme }) => theme.font.link3};
  color: ${props => props.theme.colors.redesign.db100};
  font-weight: 500;
  margin: 0;
`;

const StyledTextArea = styled(TextArea)`
  width: 100%;
  textarea {
    font: ${({ theme }) => theme.font.link3};
    font-family: ${museoSansFont};
    color: ${props => props.theme.colors.redesign.db100};
    font-weight: 500;
  }
`;

const InfoTable = styled.div<{ $hasFooter?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing.S_10};
  ${({ theme }) => theme.belowMobileBreakpoint} {
    flex-direction: column;
  }
`;

const ButtonWrapper = styled.div<{ marginTop?: string }>`
  display: flex;
  gap: ${props => props.theme.spacing.S_10};
  justify-content: center;
  margin-top: ${props => props.marginTop || props.theme.spacing.S_15};
  flex-direction: row;
  flex-wrap: wrap-reverse;

  button {
    flex-grow: 0;
  }

  ${props => props.theme.belowMobileBreakpoint} {
    flex-direction: column-reverse;
    flex-wrap: nowrap;
    align-items: stretch;
  }
`;

const HeaderRow = styled(StyledHeader)`
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const StyledTableRow = styled(TableRow)`
  padding: 16px 0;
  border-bottom: ${({ theme }) => theme.semantic.container.border};
`;

const fieldBase = css`
  color: ${({ theme }) => theme.colors.redesign.db100};
  font-weight: 500;
  border-radius: ${({ theme }) => theme.borderRadius.basic};
  background: ${({ theme }) => theme.semantic.container.background};
  ${({ theme }) => theme.belowMobileBreakpoint} {
    padding-top: 6px;
    margin: 0;
  }
`;

const fieldWithBorder = css`
  ${fieldBase};
  border: ${({ theme }) => theme.semantic.container.border};
`;

const fieldDisplay = css`
  ${fieldBase};
  border: none;
`;

const EditFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 0;
`;

const FormInput = styled(StyledInput)`
  ${fieldWithBorder};
`;

const DisplayValue = styled.div`
  ${fieldDisplay};
`;

export {
  ButtonWrapper,
  DisplayValue,
  EditFieldContainer,
  fieldBase,
  fieldDisplay,
  fieldWithBorder,
  FormInput,
  HeaderRow,
  InfoTable,
  StyledHeader,
  StyledParagraph,
  StyledTableRow,
  StyledTextArea,
  TableRow,
};
